import { createSelector } from "@ngrx/store";
import { RegistrationState } from "../registration.models";

export const selectRegistrationFeature = (state: {
  registration: RegistrationState;
}) => state.registration;
export const selectRegistrationState = createSelector(
  selectRegistrationFeature,
  (state) => state
);
export const selectRegistrationPhoneNumber = createSelector(
  selectRegistrationFeature,
  (state) => state.data.mobile.number
);
export const selectRegistrationIntent = createSelector(
  selectRegistrationFeature,
  (state) => state.intent
);
export const selectRegistrationOtpSent = createSelector(
  selectRegistrationFeature,
  (state) => state.otpSent
);
export const selectRegistrationOtpValidation = createSelector(
  selectRegistrationFeature,
  (state) => state.otpMatch
);
export const selectRegistrationRegistered = createSelector(
  selectRegistrationFeature,
  (state) => state.registered
);
export const selectRegistrationCardNumber = createSelector(
  selectRegistrationFeature,
  (state) => state.cardNumber
);
